var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29.41 29.41",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47,24.38a4.82,4.82,0,0,1-4.82-4.82V9.92A4.82,4.82,0,0,1,6.47,5.1h4.22a.6.6,0,0,1,.6.6v2a.6.6,0,0,1-.6.6H6.47A1.61,1.61,0,0,0,4.86,9.92v9.64a1.6,1.6,0,0,0,1.61,1.6h4.22a.61.61,0,0,1,.6.61v2a.6.6,0,0,1-.6.61Zm10.1-17,1.1-1.1a1.2,1.2,0,0,1,1.7,0L27,13.88a1.21,1.21,0,0,1,0,1.71l-7.63,7.57a1.22,1.22,0,0,1-1.71,0l-1.1-1.1a1.21,1.21,0,0,1,0-1.74l3.9-3.57H10.89a1.21,1.21,0,0,1-1.21-1.21v-1.6a1.21,1.21,0,0,1,1.21-1.21H20.5L16.6,9.16A1.2,1.2,0,0,1,16.57,7.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/SignOut.a84b990c.svg";
export { ForwardRef as ReactComponent };